import { render, staticRenderFns } from "./SalesLayout.vue?vue&type=template&id=638516b2&"
import script from "./SalesLayout.vue?vue&type=script&lang=js&"
export * from "./SalesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports